import React from 'react'

const About = () => {
  return (
    <div>
        <h1 className="text-6xl mb4">
        <p className='mb-4 text-2xl font-light'>
        This is a Github finder application where you can find just  <strong>anyone</strong> registered on Github.
      </p>
      <p className='text-lg text-gray-400'>
        Version <span className='text-white'>1.0.0</span>
      </p>
      <p className='text-lg text-gray-400 py-1'>
       You will find it interesting
      </p>
        </h1>
    </div>
  )
}

export default About